module.exports = __webpack_public_path__ + "img/icon_lvjing_rixi_normal@2x.92d78de7.png";